// Report JavaScript errors from customers' browsers to the team's "Checkout problems" log.
// Before this, a button that broke in WeChat's in-app browser was invisible until someone
// complained. Plain fetch (not axios: no auth refresh loops), at most 5 reports per page load,
// one per distinct message, and never on the staff dashboard.
const API = process.env.VUE_APP_API_URL;
const seen = new Set();
let sent = 0;

function send(kind, message, source, line) {
  try {
    const path = window.location.pathname || '';
    if (path.startsWith('/dashboard') || !API) return;
    const msg = String(message || '').slice(0, 240);
    if (!msg || seen.has(msg) || sent >= 5) return;
    seen.add(msg); sent += 1;
    fetch(`${API}/client-error/`, {
      method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ kind, message: msg, source: String(source || '').slice(0, 200), line: line || null, path }),
    }).catch(() => {});
  } catch (e) { /* reporting must never cause an error of its own */ }
}

export function installErrorBeacon(app) {
  window.addEventListener('error', (e) => send('error', e.message, e.filename, e.lineno));
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    if (r && (r.isAxiosError || r.response)) return;   // API errors are already logged server-side
    send('promise', (r && (r.message || r.toString())) || 'unhandled rejection');
  });
  // Vue catches errors in components and click handlers itself — they never reach window.onerror
  const prev = app.config.errorHandler;
  app.config.errorHandler = (err, vm, info) => {
    send('vue', `${(err && err.message) || err} [${info || ''}]`, err && err.stack ? String(err.stack).split('\n')[1] : '');
    if (prev) prev(err, vm, info); else console.error(err);   // eslint-disable-line no-console
  };
}
